import tagTester from './_tagTester.js';
import { isIE11 } from './_stringTagBug.js';
import { ie11fingerprint, setMethods }  from './_methodFingerprint.js';

export default isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/isSet.js
// module id = 855
// module chunks = 115